import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Snackbar } from '@scramble/ui';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { investingService } from '../../services/investingService';

export const useConfirmInvestment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      investingService
        .confirmInvestment(payload)
        .then(response => {
          const { status, data } = response;
          if (status === 200) {
            queryClient.refetchQueries({
              queryKey: [QUERY_KEYS.investing.status],
            });
            queryClient.refetchQueries({
              queryKey: [QUERY_KEYS.investing.fundraising_stats],
            });
            queryClient.refetchQueries({
              queryKey: [QUERY_KEYS.investing.investment_brands, 'confirmed'],
            });
            queryClient.refetchQueries({
              queryKey: [QUERY_KEYS.cash.balance],
            });
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.investing.pre_allocate_info],
            });
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.investing.invested_in_groups_stats],
            });
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.marketing.increased_income],
            });
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.investing.invested_countries],
            });
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.investing.repayment_schedule],
              exact: false,
            });
            Notify.success({ text: 'Investing settings saved' });
            return { data, success: true };
          }

          if (status === 422) {
            const message = data?.message;
            if (message) {
              Snackbar({ type: 'danger', text: message });
            }
            return { data, success: false };
          }

          throw new Error(data?.message);
        })
        .catch(e => {
          return { success: false, data: e.message };
        }),
  });
};
